import { ActorsList } from "./actors-list";

export function ActorsListPanel() {
	return <ActorsList />;
}
